import React from 'react';
import { Box, Typography } from '@mui/material';

export interface DetailField {
  label: string;
  value?: React.ReactNode;
}

interface IProps {
  fields: DetailField[];
}

const DetailFieldList = ({ fields }: IProps) => {
  const visible = fields.filter(
    (f) =>
      f.value !== undefined &&
      f.value !== null &&
      f.value !== '' &&
      !(typeof f.value === 'string' && f.value.trim() === '')
  );

  if (visible.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Nessun dato disponibile.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '160px 1fr' },
        rowGap: 1,
        columnGap: 2,
      }}
    >
      {visible.map((f) => (
        <React.Fragment key={f.label}>
          <Typography variant="body2" color="text.secondary">
            {f.label}
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
            {f.value}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default DetailFieldList;
